import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IEslestirmeTeslimTesellum_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEslestirmeTeslimTesellum_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isWeb: boolean;
  isWeb_dummy: boolean;
  GetProductWithCode: any[];
  GetProductWithCode_dummy: any[];
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetBoxDetailForMobile: any[];
  GetBoxDetailForMobile_dummy: any[];
  GetOrdersWithBoxId: any[];
  GetOrdersWithBoxId_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  Notify: boolean;
  Notify_dummy: boolean;
  ParseScanInput: any;
  ParseScanInput_dummy: any;
  Divide: number;
  Divide_dummy: number;
  STDEqualProductsQuerry: any[];
  STDEqualProductsQuerry_dummy: any[];
  isComp729035Visible: "visible" | "hidden";
  isComp23726Visible: "visible" | "hidden";
  isComp879050Visible: "visible" | "hidden";
  isComp722915Visible: "visible" | "hidden";
  isComp443240Visible: "visible" | "hidden";
  isComp805721Visible: "visible" | "hidden";
  isComp198736Visible: "visible" | "hidden";
  isComp984178Visible: "visible" | "hidden";
  isComp169456Visible: "visible" | "hidden";
  isComp443240Enabled: "enabled" | "disabled";
}

export class EslestirmeTeslimTesellum_ScreenBase extends React.PureComponent<
  IEslestirmeTeslimTesellum_ScreenProps,
  any
> {
  eslestirmeteslimtesellum_823519_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "c0d93c04-7b5b-4f6b-b555-43a155524921",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 554865, PropertyName: "value", Value: "Kutu Bilgileri" },
        { Id: 722915, PropertyName: "label", Value: "Kutu Okut" },
        { Id: 883207, PropertyName: "value", Value: "Kutu ID" },
        { Id: 638995, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 161778, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 502417, PropertyName: "value", Value: "Beklenen Adet" },
        { Id: 168440, PropertyName: "value", Value: "Müşteri" },
        { Id: 987806, PropertyName: "value", Value: "Malzeme Bilgisi" },
        { Id: 443240, PropertyName: "label", Value: "Malzeme Okut" },
        { Id: 876722, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 729650, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 106056, PropertyName: "value", Value: "Malzeme Adeti" },
        {
          Id: 255232,
          PropertyName: "value",
          Value: "BU MALZEMEDEN KOYULMASI GEREKEN KUTU ADETİ",
        },
        {
          Id: 765059,
          PropertyName: "label",
          Value: "Teslim Tesellümü Tamamla",
        },
        { Id: 693435, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 805721, PropertyName: "label", Value: "Kutu Ara" },
        { Id: 591837, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 198736, PropertyName: "label", Value: "Malzeme Okut" },
        { Id: 784237, PropertyName: "title", Value: "Kutu ID" },
        {
          Id: 173786,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 119468, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 164989, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 488641, PropertyName: "title", Value: "Sipariş Durumu" },
        { Id: 169456, PropertyName: "value", Value: "Bekliyor" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.eslestirmeteslimtesellum_693435_value_kuikaTextInputRef =
      React.createRef();
    this.eslestirmeteslimtesellum_591837_value_kuikaTextInputRef =
      React.createRef();
    this.eslestirmeteslimtesellum_823519_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      isWeb: false,
      GetProductWithCode: [],
      ScanBarcode: "",
      SetValueOf: "",
      GetBoxDetailForMobile: [],
      GetOrdersWithBoxId: [],
      ParseScanInput: "",
      isComp729035Visible: "hidden",
      isComp23726Visible: "hidden",
      isComp879050Visible: "hidden",
      isComp722915Visible: "hidden",
      isComp443240Visible: "hidden",
      isComp805721Visible: "hidden",
      isComp198736Visible: "hidden",
      isComp984178Visible: "hidden",
      isComp169456Visible: "hidden",
      isComp443240Enabled: "disabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("eslestirmeteslimtesellum", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.EslestirmeTeslimTesellumPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("eslestirmeteslimtesellum", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["manager"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("eslestirmeteslimtesellum", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EslestirmeTeslimTesellumPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  EslestirmeTeslimTesellumPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeTeslimTesellumPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EslestirmeTeslimTesellum",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.EslestirmeTeslimTesellumPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.isWeb = await ReactSystemFunctions.isWeb();
    stateVars.isComp722915Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp805721Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeTeslimTesellumPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeteslimtesellum_253800_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productName
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_494073_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productCode
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productCode
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeTeslimTesellumPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp722915Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    formVars.eslestirmeteslimtesellum_253800_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productName
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productName
          : null
      );

    formVars.eslestirmeteslimtesellum_494073_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productCode
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productCode
          : null
      );

    stateVars.isComp805721Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";

    stateVars.isComp169456Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "eslestirmeteslimtesellum_823519_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_722915_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "eslestirmeteslimtesellum_693435_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, stateVars.ScanBarcode),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_722915_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_722915_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_693435_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BoxIdentifier_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_693435_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_722915_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );
    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );
    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );
    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetOrdersWithBoxId = result?.data.getOrdersWithBoxId;

    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_722915_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_722915_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_722915_onClick_if21_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_722915_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp729035Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_722915_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "5e0180d9_7d47_a673_d4b2_1dde439d847b_notify",
        this.defaultML,
        "Kutuya ait sipariş bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_722915_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithBoxId !== undefined
            ? stateVars.GetOrdersWithBoxId?.length > 0
              ? stateVars.GetOrdersWithBoxId[0].id
              : null
            : this.state.GetOrdersWithBoxId?.length > 0
            ? this.state.GetOrdersWithBoxId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_722915_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_722915_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_722915_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ceb85ff4_131a_6287_e5e6_9a8f853f0c8f_notify",
        this.defaultML,
        "Kutu Bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_722915_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].id
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_722915_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_722915_onClick_else2();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );

    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );

    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );

    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );

    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );

    stateVars.dataSource_823519 =
      stateVars.GetOrdersWithBoxId ?? this.state.GetOrdersWithBoxId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_443240_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_443240_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      rawInput_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_443240_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseScanInput = result?.data.parseScanInput;
    formVars.eslestirmeteslimtesellum_853642_value =
      ReactSystemFunctions.toString(this, stateVars.ParseScanInput?.adet);
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_443240_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_443240_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ParseScanInput?.urunKod),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_443240_onClick_if2",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeteslimtesellum_253800_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productName
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_494073_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productCode
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productCode
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_443240_onClick_if21_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_443240_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeteslimtesellum_730261_value =
      ReactSystemFunctions.toString(this, stateVars.Divide);
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BaseProductCodeParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        ),
        "string"
      ),
      EqualProductCodeParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_443240_onClick_if2e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDEqualProductsQuerry = result?.data.stdEqualProductsQuerry;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_443240_onClick_if2e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeteslimtesellum_730261_value =
      ReactSystemFunctions.toString(this, stateVars.Divide);
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "a374b3e1_92cb_d2e9_e698_ced6dad77c9c_notify",
        this.defaultML,
        "Muadil ürün!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick_if2e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "03f119fc_c3c3_6d8f_5aa8_2e821befe5ac_notify",
        this.defaultML,
        "Kutuyla ürün eşleşmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick_if2e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.STDEqualProductsQuerry !== undefined
            ? stateVars.STDEqualProductsQuerry?.length > 0
              ? stateVars.STDEqualProductsQuerry[0].isEqualProduct
              : null
            : this.state.STDEqualProductsQuerry?.length > 0
            ? this.state.STDEqualProductsQuerry[0].isEqualProduct
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "558c3fe4_579c_3ea5_ec1b_f4a615087659_notify",
        this.defaultML,
        "Barkod okunmadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_443240_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(this, this.state.ParseScanInput?.adet),
        "false"
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_443240_onClick_else2();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeteslimtesellum_853642_value =
      ReactSystemFunctions.toString(this, this.state.ParseScanInput?.adet);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_765059_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_693435_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_765059_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );
    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );
    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );
    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_765059_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_765059_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeteslimtesellum_730261_value =
      ReactSystemFunctions.toString(this, stateVars.Divide);
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TeslimTesellumFinal",
      "BoxIdentifier",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].boxIdentifier
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TeslimTesellumFinal",
      "ValueOfPack",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.Divide),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EslestirmeTeslimTesellum",
      "TeslimTesellumFinal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "68955",
      null,
      null,
      "true",
      "500px",
      "35vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_765059_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TeslimTesellumFinal",
      "BoxIdentifier",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].boxIdentifier
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TeslimTesellumFinal",
      "ValueOfPack",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EslestirmeTeslimTesellum",
      "TeslimTesellumFinal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "56987",
      null,
      null,
      "true",
      "500px",
      "35vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_765059_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ParseScanInput?.adet),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_765059_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_765059_onClick_else1();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );

    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );

    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );

    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );

    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_805721_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_693435_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BoxIdentifier_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_693435_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_805721_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );
    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );
    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );
    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetOrdersWithBoxId = result?.data.getOrdersWithBoxId;

    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_805721_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_805721_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_805721_onClick_if11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_805721_onClick_if1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp729035Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_805721_onClick_if1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "543121f9_93ff_ceb9_d11c_e49fcfb311ec_notify",
        this.defaultML,
        "Kutuya ait sipariş bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_805721_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithBoxId !== undefined
            ? stateVars.GetOrdersWithBoxId?.length > 0
              ? stateVars.GetOrdersWithBoxId[0].id
              : null
            : this.state.GetOrdersWithBoxId?.length > 0
            ? this.state.GetOrdersWithBoxId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_805721_onClick_if1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_805721_onClick_if1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_805721_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "fc802ee4_99bb_d872_7bfb_61dbef64ae83_notify",
        this.defaultML,
        "Kutu Bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_805721_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].id
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_805721_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_805721_onClick_else1();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeteslimtesellum_177886_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null
      );

    formVars.eslestirmeteslimtesellum_772361_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productName
          : null
      );

    formVars.eslestirmeteslimtesellum_255624_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].productCode
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].productCode
          : null
      );

    formVars.eslestirmeteslimtesellum_804984_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      );

    formVars.eslestirmeteslimtesellum_6107_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].customerName
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].customerName
          : null
      );

    stateVars.dataSource_823519 =
      stateVars.GetOrdersWithBoxId ?? this.state.GetOrdersWithBoxId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_591837_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_198736_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeteslimtesellum_253800_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productName
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productName
          : null
      );
    formVars.eslestirmeteslimtesellum_494073_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetProductWithCode !== undefined
          ? stateVars.GetProductWithCode?.length > 0
            ? stateVars.GetProductWithCode[0].productCode
            : null
          : this.state.GetProductWithCode?.length > 0
          ? this.state.GetProductWithCode[0].productCode
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_198736_onClick_if01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_198736_onClick_if0f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeteslimtesellum_730261_value =
      ReactSystemFunctions.toString(this, stateVars.Divide);
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "184e9fbf_d976_b449_cae7_6cc6ec1ac13e_notify",
        this.defaultML,
        "Tam ürün eşleşmesi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_if0e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BaseProductCodeParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        ),
        "string"
      ),
      EqualProductCodeParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeTeslimTesellum/EslestirmeTeslimTesellumComponent_198736_onClick_if0e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDEqualProductsQuerry = result?.data.stdEqualProductsQuerry;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeTeslimTesellumComponent_198736_onClick_if0e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeteslimtesellum_730261_value =
      ReactSystemFunctions.toString(this, stateVars.Divide);
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4d467c89_7a2b_6b9f_a188_56285d9c51ed_notify",
        this.defaultML,
        "Muadil ürün!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_if0e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "5766ff55_6a89_1969_a62d_29c44fdf3066_notify",
        this.defaultML,
        "Kutuyla ürün eşleşmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_if0e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.STDEqualProductsQuerry !== undefined
            ? stateVars.STDEqualProductsQuerry?.length > 0
              ? stateVars.STDEqualProductsQuerry[0].isEqualProduct
              : null
            : this.state.STDEqualProductsQuerry?.length > 0
            ? this.state.STDEqualProductsQuerry[0].isEqualProduct
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ee92d4b6_06fe_3a01_acd8_7538f9e62e8b_notify",
        this.defaultML,
        "Malzeme kodu girilmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_198736_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeteslimtesellum_591837_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeTeslimTesellumComponent_198736_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeTeslimTesellumComponent_164989_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 68955, 56987] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.[
        "EslestirmeTeslimTesellum"
      ] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.EslestirmeTeslimTesellumPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.EslestirmeTeslimTesellumPageInit();
    }
  }
}
